import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReactCarousel from '../ReactCarousel/ReactCarousel';
import Offer from '../Offer';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import './OffersCarousel.scss';

const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1.05,
  slidesToScroll: 1,
};

const OffersItems = props => {
  if (!props.useCarousel) {
    return props.children;
  }
  return (
    <ReactCarousel settings={carouselSettings}>
      {props.children}
    </ReactCarousel>
  );
};

const OffersCarousel = props => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <section className="offers-carousel-wrapper">
      <div className="container-guttered">
        <div className="offers-carousel__title">
          <p className="text-kilo">{props.title}</p>
          <a href={localiseUrl(props.country, props.ctaLink)}>{props.ctaText}</a>
        </div>
        <div className={cx('offers-carousel', {
          'offers-carousel--horizontal': props.fabletDown
        })}>
          <OffersItems useCarousel={props.fabletDown}>
            {props.items.map((offer, key) => (
              <Offer
                description={offer.shortDescription}
                key={`offer-${key}`}
                isLayoutHorizontal={props.fabletDown}
                {...offer}
              />
            ))}
          </OffersItems>
        </div>
      </div>
    </section>
  );
};

const propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  country: PropTypes.object,
  fabletDown: PropTypes.bool,
  children: PropTypes.node,
  useCarousel: PropTypes.bool,
};

OffersItems.propTypes = propTypes;
OffersCarousel.propTypes = propTypes;

export default OffersCarousel;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OffersCarousel/OffersCarousel.js